export default __webpack_public_path__ + "static/media/tdogefood.9564899f.png";